 
import "../styles/Header.css"
import { motion } from "framer-motion"

function Header() {
  return (
    <header className="sqheader">
      <motion.div initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
        <h1>
          <span className="title-highlight">Stack</span> & <span className="title-highlight">Queue</span> Visualizer
        </h1>
        <p>Interactive visualization of fundamental data structures</p>

        <div className="sqheader-decoration">
          <div className="decoration-item"></div>
          <div className="decoration-item"></div>
          <div className="decoration-item"></div>
          <div className="decoration-item"></div>
          <div className="decoration-item"></div>
        </div>
      </motion.div>
    </header>
  )
}

export default Header

